import React from "react";
import MinhasCartelas from "./Cliente/MinhasCartelas";
import MeusPremios from "./Cliente/MeusPremios";
import LojaCliente from "./Cliente/LojaCliente";
import Ganhadores from "./Cliente/Ganhadores";
import PerfilCliente from "./Cliente/PerfilCliente";
import PerfilCambista from "./Cambista/PerfilCambista";
import CaixaCambista from "./Cambista/CaixaCambista";
import CadastroCambista from "./Cambista/CadastroCambista";
import LojaCambista from "./Cambista/LojaCambista";
import ReceberPedidos from "./Cambista/ReceberPedidos";
import GerenciarCambistas from "./Gerente/GerenciarCambistas";
import PerfilGerente from "./Gerente/PerfilGerente";
import CaixaGerente from "./Gerente/CaixaGerente";
import CadastroGerente from "./Gerente/CadastroGerente";
import CadastroCliente from "./Cambista/CadastroCliente";
import BilhetesGerente from "./Gerente/BilhetesGerente";
import Configuracoes from "./_Master/Configuracoes";
import PerfilMaster from "./_Master/PerfilMaster";
import GanhadoresMaster from "./_Master/GanhadoresMaster";
import GerarLote from "./_Master/GerarLote";
import Registro from "./_Geral/Registro";
import Login from "./_Geral/Login";
import Logout from "./_Geral/Logout";
import AuthenticatedRoute from './_Components/AuthenticatedRoute'
import GerenciaClientes from './Cambista/GerenciarClientes'
import { BrowserRouter, Switch, Route } from "react-router-dom";
import MasterCaixasCambistas from "./_Master/MasterCaixasCambistas";
import MasterCaixasGerentes from "./_Master/MasterCaixasGerentes";
import BilhetesMaster from "./_Master/BilhetesMaster";
import Sorteio from "./_Master/Sorteio";
import { GerenciarGerentes } from "./_Master/GerenciarGerentes";
import CaixasCambistas from "./Gerente/CaixasCambistas";
import ValidacaoRegistro from './_Geral/ValidacaoRegistro'
import MasterReceberPedidos from "./_Master/MasterReceberPedidos";
import MasterGerenciarClientes from "./_Master/MasterGerenciarClientes";
import MasterCadastroCliente from "./_Master/MasterCadastroCliente";
import CaixaMaster from "./_Master/CaixaMaster";
import Regulamento from "./_Geral/Regulamento";
import MasterGerenciarCambistas from "./_Master/MasterGerenciarCambistas";
import MasterCadastroCambista from "./_Master/MasterCadastroCambista";
import PrinterPage from "./_Components/PrinterPage";
import SorteioGiro from "./_Master/SorteioGiro";
import ExtrairCartelasAvulsas from "./_Master/ExtrairCartelasAvulsas"
import ImprimirCartelasAvulsas from "./Gerente/ImprimirCartelasAvulsas";
import { GerenteCriarPedidos } from "./Gerente/GerenteCriarPedidos";
import PrinterPageSerie from "./_Components/PrinterPageSerie";
import VerificarDuplicadas from './_Geral/VerificarDuplicadas'
import ListaGanahdores from "./_Geral/ListaGanhadores";
import InformacoesSistema from "./_Master/InformacoesSistema";
import AnaliseDuplicidade from "./_Geral/AnaliseDuplicidade";
import AcompanharCartelas from "./_Geral/AcompanharCartelas";
import CartelasAtuais from "./_Geral/CartelasAtuais";
import PreencherCadastro from "./Cliente/PreencherCadastro"
import Relatorios from "./_Master/Relatorios";
import BuscarCartela from "./_Master/BuscarCartela";
import RelatoriosGerente from "./Gerente/RelatoriosGerente";
import RelatoriosCambista from "./Cambista/RelatoriosCambista";
import MasterCriarPedidos from "./_Master/MasterCriarPedidos";
import GanhadoresGerente from "./Gerente/GanhadoresGerente";
import EditarPedido from "./_Master/EditarPedido";
import GerenteBuscarCartela from "./Gerente/GerenteBuscarCartela";
import Axios from 'axios'
import AGeradorDeLotes from "./_Geral/AGeradorDeLotes";
import ConfigGiro from "./_Master/ConfigGiro";
import SubMasterReceberPedidos from "./_SubMaster/SubMasterReceberPedidos";
import SubMasterRecebidos from "./_SubMaster/SubMasterRecebidos";
import GerenciarMonitores from "./_Master/GerenciarMonitores";
import MasterCadastroMonitor from "./_Master/MasterCadastroMonitor";
import BilhetesMonitor from "./_SubMaster/BilhetesMonitor";
import SubMasterGerenciarClientes from "./_SubMaster/SubMasterGerenciarClientes";
import SubMasterCadastroCliente from "./_SubMaster/SubMasterCadastroCliente";
import GerenciarSeries from "./_Master/GerenciarSeries";
import Validador from "./_Geral/ValidarCartela";
import Privacy from "./_Geral/Privacy";
import MobileRegister from "./_Geral/MobileRegister";
import DownloadPage from "./_Geral/DownloadPage";
import PrinterPageSerieQRCODE from "./_Components/PrinterPageSerieQRCODE";
import RecuperarSenha from "./_Geral/RecuperarSenha";
import GanhadoresGeralMaster from "./_Master/GanhadoresGeralMaster";
import MasterSolicitacoes from "./_Master/MasterSolicitacoes";
import MasterCadastroAdmin from "./_Master/MasterCadastroAdmin";
import GerenciarAdmins from "./_Master/GerenciarAdmins";
import AdminGerenciarGerentes from "./Admins/AdminGerenciarGerentes";
import AdminCadastroGerente from "./Admins/AdminCadastroGerente";
import AdminRelatorios from "./Admins/AdminRelatorios";


async function serieSetBusy(_id, isBusy) {
    try {
        var axiosInstance = new Axios.create({
            baseURL: window.localStorage.getItem('apiUrl')
        })
        const response = await axiosInstance.put('series/set-busy', { _id, isBusy })
    } catch (err) {
        console.log(err)
    }
}


function App() {
    window.localStorage.setItem("apiUrl", "https://api.cartelas.app/api/");

    if (localStorage.getItem('user') && localStorage.getItem('user').perfil == 'GERENTE' && localStorage.getItem('serie')) {
        serieSetBusy(localStorage.getItem('serie'), false)
    }

    return (
        <BrowserRouter>
            <Switch>
                <Route path="/app" exact component={DownloadPage} />
                <Route path="/" exact component={Login} />
                <Route path="/login" exact component={Login} />
                <Route path="/geral-ganhadores" exact component={ListaGanahdores} />
                <Route path="/logout" exact component={Logout} />
                <Route path="/registrar" exact component={Registro} />
                <Route path="/validacao-registro" exact component={ValidacaoRegistro} />
                <Route path="/regulamento" exact component={Regulamento} />
                <Route path="/imprimir" exact component={PrinterPage} />
                <Route path="/imprimir-serie" exact component={PrinterPageSerie} />
                <Route path="/imprimir-serie-qrcode" exact component={PrinterPageSerieQRCODE} />
                <Route path="/verificar-duplicadas" exact component={VerificarDuplicadas} />
                <Route path="/analise-duplicidade" exact component={AnaliseDuplicidade} />
                <Route path="/acompanhar-cartelas" exact component={AcompanharCartelas} />
                <Route path="/cartelas-atuais" exact component={CartelasAtuais} />
                <Route path="/preencher-cadastro" exact component={PreencherCadastro} />
                <Route path="/banco-de-lotes-generator" exact component={AGeradorDeLotes} />
                <Route path="/validar/" component={Validador} />
                <Route path="/privacy/" component={Privacy} />
                <Route path="/signup/" component={MobileRegister} />
                <Route path="/recuperar-senha" component={RecuperarSenha} />
                

                {/* EXCLUSIVOS DO MASTER */}
                <AuthenticatedRoute path="/gerar-lotes" auth={['MASTER']}
                    component={GerarLote} />
                <AuthenticatedRoute path="/sorteio-giro" auth={['MASTER']}
                    component={SorteioGiro} />
                <AuthenticatedRoute path="/perfil-master" auth={['MASTER']}
                    component={PerfilMaster} />
                <AuthenticatedRoute path="/configuracoes" auth={['MASTER']}
                    component={Configuracoes} />
                <AuthenticatedRoute path="/master-gerenciar-gerentes" auth={['MASTER']}
                    component={GerenciarGerentes} />
                <AuthenticatedRoute path="/master-gerenciar-monitores" auth={['MASTER']}
                    component={GerenciarMonitores} />
                <AuthenticatedRoute path="/master-bilhetes" auth={['MASTER']}
                    component={BilhetesMaster} />
                <AuthenticatedRoute path="/master-caixas-por-gerentes"
                    auth={['MASTER']}
                    component={MasterCaixasGerentes} />
                <AuthenticatedRoute path="/master-caixas-por-cambistas"
                    auth={['MASTER']}
                    component={MasterCaixasCambistas} />
                <AuthenticatedRoute path="/master-gerenciar-gerentes" auth={['MASTER']}
                    component={GerenciarGerentes} />
                <AuthenticatedRoute path="/cadastro-gerente" auth={['MASTER']}
                    component={CadastroGerente} />
                <AuthenticatedRoute path="/cadastro-monitor" auth={['MASTER']}
                    component={MasterCadastroMonitor} />

                <AuthenticatedRoute path="/master-ganhadores" auth={['MASTER']}
                    component={GanhadoresMaster} />
                
                <AuthenticatedRoute path="/master-ganhadores-geral" auth={['MASTER']}
                    component={GanhadoresGeralMaster} />

                <AuthenticatedRoute path="/master-cadastro-cliente" auth={['MASTER']}
                    component={MasterCadastroCliente} />
                <AuthenticatedRoute path="/master-cadastro-cambista" auth={['MASTER']}
                    component={MasterCadastroCambista} />
                <AuthenticatedRoute path="/master-gerenciar-cambistas" auth={['MASTER']}
                    component={MasterGerenciarCambistas} />

                <AuthenticatedRoute path="/sorteio" auth={['MASTER']}
                    component={Sorteio} />
                <AuthenticatedRoute path="/master-caixa" auth={['MASTER']}
                    component={CaixaMaster} />
                <AuthenticatedRoute path="/buscar-cartela" auth={['MASTER']}
                    component={BuscarCartela} />

                <AuthenticatedRoute path="/master-recebe-pedidos" auth={['MASTER']}
                    component={MasterReceberPedidos} />
                <AuthenticatedRoute path="/master-gerenciar-clientes" auth={['MASTER']}
                    component={MasterGerenciarClientes} />
                <AuthenticatedRoute path="/extrair-cartelas-avulsas" auth={['MASTER']}
                    component={ExtrairCartelasAvulsas} />
                <AuthenticatedRoute path="/master-info" auth={['MASTER']}
                    component={InformacoesSistema} />
                <AuthenticatedRoute path="/master-relatorios" auth={['MASTER']}
                    component={Relatorios} />
                <AuthenticatedRoute path="/master-criar-pedidos" auth={['MASTER']}
                    component={MasterCriarPedidos} />
                <AuthenticatedRoute path="/editar-pedido" auth={['MASTER']}
                    component={EditarPedido} />
                <AuthenticatedRoute path="/configuracao-giro" auth={['MASTER']}
                    component={ConfigGiro} />
                <AuthenticatedRoute path="/master-solicitacoes-saque" auth={['MASTER']}
                    component={MasterSolicitacoes} />
                <AuthenticatedRoute path="/cadastro-admin" auth={['MASTER']}
                    component={MasterCadastroAdmin} />
                <AuthenticatedRoute path="/master-gerenciar-admins" auth={['MASTER']}
                    component={GerenciarAdmins} />

                <AuthenticatedRoute path="/master-gerenciar-series" auth={['MASTER']}
                    component={GerenciarSeries} />

                {/* EXCLUSIVOS DO ADMINS */}
                <AuthenticatedRoute path="/admin-cadastro-gerente" auth={['ADMIN']} component={AdminCadastroGerente} />
                <AuthenticatedRoute path="/admin-gerenciar-gerentes" auth={['ADMIN']} component={AdminGerenciarGerentes} />
                <AuthenticatedRoute path="/admin-relatorios" auth={['ADMIN']} component={AdminRelatorios} />
                {/* EXCLUSIVOS DO SUBMASTER */}
                <AuthenticatedRoute path="/monitoria-receber" auth={['SUBMASTER']} component={SubMasterReceberPedidos} />
                <AuthenticatedRoute path="/monitoria-recebidos" auth={['SUBMASTER']} component={SubMasterRecebidos} />
                <AuthenticatedRoute path="/monitoria-historico" auth={['SUBMASTER']} component={BilhetesMonitor} />
                <AuthenticatedRoute path="/monitoria-clientes" auth={['SUBMASTER']} component={SubMasterGerenciarClientes} />
                <AuthenticatedRoute path="/monitoria-cadastros" auth={['SUBMASTER']}
                    component={SubMasterCadastroCliente} />
                {/* EXCLUSIVOS DO GERENTE */}
                <AuthenticatedRoute path="/gerente-bilhetes" auth={['GERENTE']}
                    component={BilhetesGerente} />
                <AuthenticatedRoute path="/caixa-gerente" auth={['GERENTE']}
                    component={CaixaGerente} />
                <AuthenticatedRoute path="/perfil-gerente" auth={['GERENTE']}
                    component={PerfilGerente} />
                <AuthenticatedRoute path="/gerente-gerencia-cambistas"
                    auth={['GERENTE']} component={GerenciarCambistas} />
                <AuthenticatedRoute path="/imprimir-cartelas-avulsas"
                    auth={['GERENTE']} component={ImprimirCartelasAvulsas} />
                <AuthenticatedRoute path="/gerente-criar-pedidos"
                    auth={['GERENTE']} component={GerenteCriarPedidos} />
                <AuthenticatedRoute path="/relatorios-gerente"
                    auth={['GERENTE']} component={RelatoriosGerente} />
                <AuthenticatedRoute path="/gerente-busca-cartela"
                    auth={['GERENTE']} component={GerenteBuscarCartela} />
                <AuthenticatedRoute path="/gerente-ganhadores"
                    auth={['GERENTE']} component={GanhadoresGerente} />
                {/* <AuthenticatedRoute path="/g-criar-pedido"
                                    auth={['GERENTE']} component={GCriarPedidos}/> */}




                {/* EXCLUSIVOS DO CAMBISTA */}
                <AuthenticatedRoute path="/cambista-gerencia-clientes"
                    auth={['CAMBISTA']} component={GerenciaClientes} />
                <AuthenticatedRoute path="/loja-cambista" auth={['CAMBISTA']}
                    component={LojaCambista} />
                <AuthenticatedRoute path="/caixa-cambista" auth={['CAMBISTA']}
                    component={CaixaCambista} />
                <AuthenticatedRoute path="/perfil-cambista" auth={['CAMBISTA']}
                    component={PerfilCambista} />
                <AuthenticatedRoute path="/relatorios-cambista" auth={['CAMBISTA']}
                    component={RelatoriosCambista} />


                {/* EXCLUSIVOS DO CLIENTE */}
                <AuthenticatedRoute path="/perfil-cliente" auth={['CLIENTE']}
                    component={PerfilCliente} />
                <AuthenticatedRoute path="/loja-cliente" auth={['CLIENTE']}
                    component={LojaCliente} />
                <AuthenticatedRoute path="/meus-premios" auth={['CLIENTE']}
                    component={MeusPremios} />
                <AuthenticatedRoute path="/minhas-cartelas" auth={['CLIENTE']}
                    component={MinhasCartelas} />


                {/* MEXIDOS */}
                <AuthenticatedRoute path="/caixas-por-cambistas" auth={['GERENTE', 'MASTER']}
                    component={CaixasCambistas}
                />
                <AuthenticatedRoute path="/cadastro-cliente" auth={['CAMBISTA', 'MASTER', 'SUBMASTER']}
                    component={CadastroCliente} />
                <AuthenticatedRoute path="/cadastro-cambista" auth={['GERENTE', 'MASTER']}
                    component={CadastroCambista} />
                <AuthenticatedRoute path="/receber-pedidos" auth={['CAMBISTA', 'MASTER']}
                    component={ReceberPedidos} />
                <AuthenticatedRoute path="/ganhadores" component={Ganhadores}
                    auth={['CLIENTE', 'GERENTE', 'CAMBISTA', 'MASTER']} />


                <AuthenticatedRoute path="/oops" auth={['CLIENTE', 'GERENTE', 'CAMBISTA', 'MASTER', 'SUBMASTER']} component={() => <h1>Página não autorizada.</h1>} />
                <Route path="*" component={() => <h1>Página não encontrada!</h1>} />
            </Switch>
        </BrowserRouter>
    )
}

export default App;
